import React, { useMemo, useState } from "react";
import "./ProposalCoursesSelect.scss";
import { useSelector } from "react-redux";
import { images } from "../../constants";
import LoaderDots from "../generalComponents/LoaderDots";
import FormSpecialAddCourse from "./FormSpecialAddCourse";
import { useForm } from "../hooks/useForm";
import { getCourseByName } from "../../helper/CourseFilters";
import AlertPopUp from "../generalComponents/AlertPopUp";

const ProposalCoursesSelect = () => {
  const [formValues, handleInputchange, reset] = useForm({
    searchText: "",
  });
  const { searchText } = formValues;
  const [searching, setSearching] = useState(false);
  const [filtered, setFiltered] = useState([]);

  const { courses } = useSelector((state) => state.courses);
  const { ui } = useSelector((state) => state.ui);

  //Helpers
  const courseBynameFiltered = useMemo(
    () => getCourseByName(courses, searchText),
    [searchText, courses]
  );
  //Handlers
  const handleCourseSearch = (e) => {
    e.preventDefault();

    if (searchText.trim() !== "") {
      setSearching(true);
    }

    if (courseBynameFiltered.length !== 0) {
      setFiltered(courseBynameFiltered);
    }
    if (courseBynameFiltered.length === 0) {
      setFiltered([]);
    }
  };

  const handleClear = () => {
    setFiltered([]);
    setSearching(false);
    reset();
  };

  if (courses.length === 0) {
    return <LoaderDots />;
  }
  return (
    <div className="courses-select">
      <div className="main__search-bar">
        <form onSubmit={handleCourseSearch} className="main__search-bar--form">
          <input
            type="text"
            name="searchText"
            value={searchText}
            onChange={handleInputchange}
            placeholder={`Search...`}
            className="main__search-bar--input tx__sb-gray"
          />
          <button type="submit">
            <img src={images.IconSearch} alt="Icon-Search" />
          </button>
        </form>
        <div className="main__search-bar--bottom">
          {filtered.length !== 0 && (
            <button onClick={handleClear} className="tx__cl-gray">
              Clear All
            </button>
          )}
        </div>
      </div>

      <div>
        {searching ? (
          <div>
            {filtered.length !== 0 ? (
              <ul className="courses-select__list-container">
                {filtered?.map((course) => (
                  <div key={course._id} className="course-select__item">
                    <div className="course-select-item__heading">
                      <div className="course-select-item__heading--img">
                        <img src={images.IconCourseR} alt="" />
                      </div>
                      <div className="course-select-item__heading--name">
                        <h3 className="title-gray-bold-16">{course.name}</h3>
                        <h3 className="title-gray-reg-12">
                          by {course.college.name}
                        </h3>
                      </div>
                    </div>

                    <div>
                      <FormSpecialAddCourse course={course} />
                    </div>
                  </div>
                ))}
              </ul>
            ) : (
              <div className="courseMain__alert">
                <div className="courseMain__alert--wrapper">
                  <AlertPopUp msg={`Search not found`} type={400} />
                  <button className="btn-primary" onClick={handleClear}>
                    Continue
                  </button>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div>
            {courses.length !== 0 ? (
              <>
                <ul className="courses-select__list-container">
                  {courses?.map((course) => (
                    <div key={course._id} className="course-select__item">
                      <div className="course-select-item__heading">
                        <div className="course-select-item__heading--img">
                          <img src={images.IconCourseR} alt="" />
                        </div>
                        <div className="course-select-item__heading--name">
                          <h3 className="title-gray-bold-16">{course.name}</h3>
                          <h3 className="title-gray-reg-12">
                            by {course.college.name}
                          </h3>
                        </div>
                      </div>

                      <div>
                        <FormSpecialAddCourse course={course} />
                      </div>
                    </div>
                  ))}
                </ul>
              </>
            ) : (
              <div>
                {ui.loading ? (
                  <LoaderDots />
                ) : (
                  <AlertPopUp msg={`Courses not found`} type={400} />
                )}
              </div>
            )}
          </div>
        )}
      </div>

      {/* <ul className="courses-select__list-container">
        {courses?.map((course) => (
          <div key={course._id} className="course-select__item">
            <div className="course-select-item__heading">
              <div className="course-select-item__heading--img">
                <img src={images.IconCourseR} alt="" />
              </div>
              <div className="course-select-item__heading--name">
                <h3 className="title-gray-bold-16">{course.name}</h3>
                <h3 className="title-gray-reg-12">by {course.college.name}</h3>
              </div>
            </div>

            <div>
              <FormSpecialAddCourse course={course} />
            </div>
          </div>
        ))}
      </ul> */}
    </div>
  );
};

export default ProposalCoursesSelect;
